module.exports = __webpack_public_path__ + "static/media/img25.6c6a865d.JPG";